module.exports = __webpack_public_path__ + "static/media/20ECE24.38f17f9c.jpg";